<template>
  <div class="ch-component-warpper">
    <div class="ch-component ch-detail-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper ch-detail-page">
        <v-layout row wrap>
          <v-flex xs-12>
            <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
              <span class="ch-menu-btn-icon" v-show="navigationDrawer">
                <i class="fas fa-minus fa-fw"></i>
              </span>
              <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
                <i class="fas fa-plus fa-fw"></i>
              </span>
            </button> -->
            <span class="ch-component-title ml-2">ADMIN Detail</span>
          </v-flex>
        </v-layout>
      </v-container>
      <admins-detail-info></admins-detail-info>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import AdminsDetailInfo from '@/components/admin/admins/AdminsDetailInfo';

  export default {
    data() {
      return {
        // NOTE: Full screen dialog
        dialog: false,
        navigationDrawer: true,
      };
    },
    methods: {
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      AdminsDetailInfo,
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/AdminsDetail.vue